import type { Address } from './Address';
import type { Card } from './Card';

export class User {
  readonly address: Address[] = [];
  readonly cards: Card[] = [];
  readonly midname!: string;
  readonly name!: string;
  readonly people_main_id!: number;
  readonly surname!: string;
  readonly user_id!: number;
  readonly birthdate?: string;
  readonly email?: string;
  readonly bonus_balance?: number;
  readonly avatar?: string;
  readonly flow?: 'form_only' | 'file_only' | 'hybrid';
  /** false — нужно согласие с политикой ПДн; true если нет active doc или есть consent */
  readonly legal_agreement_accepted?: boolean;
  readonly legal_agreement_version?: number | null;

  get fullName(): string {
    return [this.name, this.midname, this.surname].filter(Boolean).join(' ');
  }
}
